import React from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";

import Anchor from "../Anchor";

import { staticTexts } from "../../utils/Translate";

import "./buttonOutline.m.css";

const ButtonOutline = ({ story = {}, lang }) => {
  const { headline, url } = story;

  return (
    <Anchor styleName="button" className="button-outline" aria-label={headline} href={url}>
      {staticTexts(lang).readDetails}
    </Anchor>
  );
};

ButtonOutline.propTypes = {
  story: object.isRequired,
  lang: string,
};

const mapStateToProps = (state) => ({
  lang: state?.qt?.config?.["publisher-attributes"]?.lang || "",
});

export default connect(mapStateToProps)(ButtonOutline);
